import React, { useEffect } from "react";
import AOS from "aos";
import { skillsData } from "./skillsData";
import "./skills.scss";

const SkillCard = ({ skill, i }) => {
  return (
    <div
      className="skill-card-1 has_fade_anim"
      data-fade-from="left"
      data-delay={200 * (i + 1)}
    >
      <img
        width={48}
        height={48}
        style={{ width: "auto" }}
        src={skill.image}
        alt={`${skill.name} Icon`}
      />
      {/* <h4 className="percentage">{skill.percentage}%</h4> */}
      <h5 className="title">{skill.name}</h5>
    </div>
  );
};

const Skills = () => {
  useEffect(() => {
    AOS.init({
      duration: 2000,
      once: true,
      easing: "ease",
      offset: 100,
    });
  }, []);
  return (
    <section className="portfolio">
      <div className="shape"></div>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="block-text center">
              <h6 className="sub-heading">
                <span>Skills</span>
              </h6>
              <h3 className="heading pd">My Advantage</h3>
            </div>
          </div>
          <div className="">
            <section className="dev-skill">
              <div className="container">
                <div className="grid-3">
                  {skillsData.map((skill, index) => (
                    <SkillCard
                      key={`skill-${index}`}
                      skill={skill}
                      index={index}
                    />
                  ))}
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
